
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {appointmentAudit, getAppointmentTable, permissionList} from "@/api/http";
import { appointmentParameter } from "@/assets/types/common";

const orderStatusNav: Array<{ name: string; id: number }> = [
    {
        name: "待受理",
        id: 0,
    },
    {
        name: "已受理",
        id: 1,
    },
    {
        name: "已取消",
        id: -1,
    },
];

const columnList: Array<any> = [
    {
        prop: "project_name",
        label: "服务类型",
        width: 100,
    },
    {
        prop: "create_time",
        label: "预约时间",
        width: 160,
    },
    {
        prop: "vehicle_code",
        label: "预约车辆",
        width: 160,
    },
    {
        prop: "user_id",
        label: "会员ID",
        width: 100,
    },
    {
        prop: "phone",
        label: "会员手机号",
        width: 160,
    },
    {
        prop: "status_text",
        label: "订单状态",
        width: 120,
    },
];

import {useRouter} from 'vue-router'
export default defineComponent({
    name: "AppointmentManagement",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['预约管理']);
        const Router = useRouter()
        let pageSize = ref(10),
            currentPage = ref(1),
            orderStatus = ref(0),
            loading = ref(false),
            total = ref(0),
            roleList = ref({} as any),
            headClass = inject("headClass"),
            project = ref([]),
            tableData = ref([] as Array<any>),
            selectGroup = reactive({
                status: "",
                date: "",
                search: "",
            }),
            screenParameter: appointmentParameter = {
                page: currentPage.value,
                pagesize: pageSize.value,
                status: orderStatusNav[orderStatus.value].id,
            };

        let getTableData = () => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'operate_preabout',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                getAppointmentTable(screenParameter).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    project.value = res?.content?.project || [];
                    loading.value = false;
                    total.value = res?.content?.count || 0;
                });
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            columnChange = (id: number, type: boolean, status: number) => {
                console.log(type)
                if (type) {
									loading.value = true;
									//受理、取消预约
                    appointmentAudit({
                        id: id,
                        status,
                    }).then((res: any) => {
                        getTableData();
                    });
                } else {
                    Router.push({
                        path:'/cashRegister/billing',
                        query:{
                            type:1
                        }
                    })
                }
            },
            screenChange = (
                e: string | Array<Date>,
                key: keyof appointmentParameter
            ): void => {
                if (!e) {
                    delete screenParameter[key];
                } else {
                    if (key == "start_date") {
                        let date = [];
                        screenParameter["start_date"] = new Date(
                            e[0]
                        ).getTime();
                        screenParameter["end_date"] = new Date(e[1]).getTime();
                    } else {
                        screenParameter["search"] = e as string;
                    }
                }
                getTableData();
            };

        onMounted(() => {
            getTableData();
        });

        watch(orderStatus, (newValue, oldValue) => {
            screenParameter.status = orderStatusNav[newValue].id;
            getTableData();
        });

        return {
            selectGroup,
            pageSize,
            currentPage,
            orderStatusNav,
            orderStatus,
            columnList,
            loading,
            tableData,
            project,
            handleSizeChange,
            handleCurrentChange,
            total,
            columnChange,
            headClass,
            roleList,
            screenChange,
        };
    },
});
